module.exports = {"title":"고고밴 404","404_title":"","404_body":["요청하신 페이지를 찾을 수 없습니다."],"404_sub":"","404_links_title":"유용한 다른 링크:","404_links_button_link_title":"고고밴 홈"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/kr/setting/404/locale.json
// module id = 666
// module chunks = 0 1 2 3 4 5